<template>
    <div class="depth">
        <div :id="containerId" class="depth_container"></div>
    </div>
</template>

<script type="text/ecmascript-6">
    const Highcharts = require('highcharts');

    export default {
        name: 'depth',
        /*props: {
            orderList: Object
        },*/
        data() {
            return {
                containerId: `depth_container_${+new Date()}`
            }
        },
        mounted() {
            this.initDepth()
        },
        watch: {
            orderList: function (val) {
                const duration = 3000 // 3000ms
                this.newT && clearTimeout(this.newT)
                this.newT = setTimeout(this.updateChart, duration) // 防抖，保证最后更新最新的数据
                // 节流更新，每3000ms内最多只更新一次，更新
                const now = +new Date()

                if(this.time && (this.time + duration > now)) {
                    return
                }
                this.time = now
                this.updateChart()
            }
        },
        methods: {
            // 初始化深度图
            initDepth() {
                const {dataX, sellDataY, buyDataY} = this.handleData()
                if(!sellDataY.length && !buyDataY.length) return

                const priceText = this.$t('m.component.deal.depth.priceText')
                const totalText = this.$t('m.component.deal.depth.totalText')
                const options = {
                    chart: {
                        backgroundColor: '#ffffff',
                        type: 'area'
                    },
                    title: {
                        text: null
                    },
                    legend: {
                        enabled: false,
                    },
                    credits: {
                        enabled: false,
                    },
                    xAxis: {
                        allowDecimals: true,
                        // labels: {
                        //     formatter: function () {
                        //         return dataX[this.value]
                        //     },
                        // },
                        categories: dataX,
                        tickmarkPlacement: 'on'
                    },
                    yAxis: {
                        title: {
                            enabled: false,
                        },
                        allowDecimals: true,
                        startOnTick: false,
                        tickWidth: 1,
                        gridLineWidth: 0,
                        labels: {
                            formatter: function () {
                                this.value = this.value >= 1000 ? this.value / 1000 + 'k' : this.value
                                return this.value;
                            }
                        }
                    },
                    tooltip: {
                        headerFormat: '',
                        pointFormatter: function () {
                            return `<b>${priceText}: ${dataX[this.x]}</b><br/><b>${totalText}： ${this.y}</b>`
                        }
                    },
                    plotOptions: {
                        area: {
                            marker: {
                                enabled: false,
                                symbol: 'circle',
                                radius: 4,
                                states: {
                                    hover: {
                                        enabled: true
                                    }
                                }
                            },
                            animation: false,
                        }
                    },
                    series: [
                        {
                            color: 'rgb(52, 167, 83)',
                            id: 'buyDataY',
                            data: buyDataY
                        },
                        {
                            color: 'rgb(234, 66, 54)',
                            id: 'sellDataY',
                            data: sellDataY
                        }
                    ]
                }

                this.depthChart = Highcharts.chart(this.containerId, options);
            },
            handleData() {
                const buyList = this.klineOrderList.buyList.sort((a, b) => a.price - b.price) // 排序，价格由小到大
                const sellList = this.klineOrderList.sellList.sort((a, b) => a.price - b.price) // 排序，价格由小到大
                const dataX = [...buyList, ...sellList].map(item => item.price)
                let buyDataY = []
                let total = this.toBigNumber(0)
                buyList.reverse().forEach(item => {
                    total = total.plus(this.toBigNumber(item.surplusAll))
                    buyDataY.push(Number(total))
                })
                buyDataY = buyDataY.reverse()
                total = this.toBigNumber(0)
                let sellDataY = []
                sellList.forEach(item => {
                    total = total.plus(this.toBigNumber(item.surplusAll))
                    sellDataY.push(Number(total))
                })

                const l = buyDataY.length + sellDataY.length
                sellDataY = sellDataY.reverse()
                for (let i = 0; i < l; i++) {
                    if (i > buyDataY.length - 1) {
                        buyDataY.push(null)
                    }
                    if (i > sellDataY.length - 1) {
                        sellDataY.push(null)
                    }
                }
                sellDataY = sellDataY.reverse()
                return {
                    dataX,
                    sellDataY,
                    buyDataY
                }
            },
            updateChart() {
                if(this.depthChart){
                    const {dataX, sellDataY, buyDataY} = this.handleData()
                    if(!sellDataY.length && !buyDataY.length) {
                        this.depthChart.destroy()
                        this.depthChart = null
                        return
                    }
                    const priceText = this.$t('m.component.deal.depth.priceText')
                    const totalText = this.$t('m.component.deal.depth.totalText')
                    this.depthChart.update({
                        xAxis: {
                            allowDecimals: true,
                            categories: dataX,
                            tickmarkPlacement: 'on'
                        },
                        tooltip: {
                            headerFormat: '',
                            pointFormatter: function () {
                                return `<b>${priceText}: ${dataX[this.x]}</b><br/><b>${totalText}： ${this.y}</b>`
                            }
                        },
                        series: [
                            {
                                color: 'rgb(52, 167, 83)',
                                id: 'buyDataY',
                                data: buyDataY
                            },
                            {
                                color: 'rgb(234, 66, 54)',
                                id: 'sellDataY',
                                data: sellDataY
                            }
                        ]
                    })
                }else {
                    this.initDepth()
                }
            }
        },
        destroyed() {
            this.depthChart && this.depthChart.destroy()
            this.depthChart = null
        }
    }
</script>
<style scoped lang="scss">
    .depth {
        width: 100%;
        height: 100%;
        .depth_container {
            width: 100%;
            height: 100%;
        }
    }
</style>
